import { TraceConfigSeed } from "./Types/Trace"

// Detect if a value is undefined, null, or NaN and return the default instead.
// If the value is a number, return the number.
export function valueOrDefault(value: number | null | undefined, defaultValue: number = 0): number {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return defaultValue
    }

    return value
}

// Detect if the value is null or NAN and give "undefined" instead.
export function valueOrMissing(value: number | null | undefined): number | undefined {
    if (value === null || Number.isNaN(value)) {
        return undefined
    }

    return value
}

export type DateFormatterOptions = {
    timeZone?: string
    timeZoneName?: boolean
    timeOnly?: boolean
    seconds?: boolean
    milliseconds?: boolean
    hourCycle?: string
}

export function formatDate(date: Date, options: DateFormatterOptions={}) {
    try {
        // The date is zoned to the time zone of the patient file. toLocaleTimeString works with UTC.
        const dateFormatOptions: Intl.DateTimeFormatOptions & { fractionalSecondDigits?: number; hourCycle?: string } = {
            hour: "numeric",
            minute: "numeric",
            timeZone: options.timeZone
        }

        if (options.seconds) {
            dateFormatOptions.second = "numeric"
        }

        if (options.milliseconds) {
            dateFormatOptions.fractionalSecondDigits = 3
        }

        if (options.timeZone) {
            dateFormatOptions.timeZone = options.timeZone
        }

        if (options.hourCycle) {
            dateFormatOptions.hourCycle = options.hourCycle
        }

        if (options.timeZoneName) {
            dateFormatOptions.timeZoneName = "shortGeneric"
        }

        if (!options.timeOnly) {
            dateFormatOptions.month = "short"
            dateFormatOptions.day = "2-digit"
            dateFormatOptions.year = "numeric"
        }

        if (options.timeOnly) {
            return date.toLocaleTimeString("en-us", dateFormatOptions)
        }

        return date.toLocaleString("en-us", dateFormatOptions)

    } catch (error) {
        return `${error}`
    }
}

export const equalsTraceOptionOrString = (a: TraceConfigSeed | string, b: TraceConfigSeed | string): boolean => {
    // Compatibility function for selecting a string value, but using a trace option in the dropdown
    if (typeof a === "string" && typeof b === "string") {
        return a === b
    }

    if (typeof a === "object" && typeof b === "object") {
        return a.rawDataKey === b.rawDataKey
    }

    if (typeof a === "string" && typeof b === "object") {
        return a === b.rawDataKey
    }

    if (typeof a === "object" && typeof b === "string") {
        return a.rawDataKey === b
    }

    return false
}
